// Cart-line identity on the storefront (Sep 2026, restored to `main`).
//
// The SERVER owns the real rule (`retail/cart.py::add_item`): a line is
// identified by the product row plus the customer's selected spice
// level, so the same dish ordered Low and ordered Hot is two lines
// while the same dish ordered twice at the same heat merges.
//
// This mirrors that rule for the UI's own lookup — "is THIS card's
// current selection already in the cart, and at what quantity?" — so a
// card showing Hot steps the Hot line and never the Low one. It is
// display-only: nothing here is ever sent to the server, and the server
// re-derives the identity itself on every mutation.
//
// Item-level Takeout is deliberately NOT part of the key: it is toggled
// on a line that already exists and must not split it.
export function cartLineKey(productId, spiceLevel) {
  return `${productId || ""}::${spiceLevel || ""}`;
}

/** Index a cart's items by that identity. */
export function indexCartItems(items) {
  const map = new Map();
  for (const it of items || []) {
    map.set(cartLineKey(it.product_id, it.spice_level), it);
  }
  return map;
}

export default cartLineKey;
